<template>
  <article v-if="loaded" class="minhaconta__body presentation">
    <p class="section__description">
      Digite aqui uma breve descrição profissional. Esse texto
      será visualizado pelos pacientes que buscarem mais
      informações sobre seu perfil.
    </p>

    <form @submit.prevent="submit()" class="presentation__form">
      <div class="presentation__wrapper" :class="presentation.length >= 400 ? 'has-error' : ''">
        <textarea
          v-model="presentation"
          maxlength="400"
          class="presentation__field"
          rows="10"
          cols="1"
        >
        </textarea>

        <p :class="presentation.length > 450 ? 'text-error' : ''">
          caracteres restantes: {{400 - presentation.length}}
        </p>
      </div>

      <dr-submit
        :disabled="presentation.length === 0"
        :sending="sending"
        text="Salvar apresentação"
        size="md"
      />
    </form>
  </article>
</template>

<script>
import drSubmit from '@/components/form/submit'

export default {
  components: {
    drSubmit
  },
  data () {
    return {
      loaded: false,
      sending: false,
      presentation: ''
    }
  },
  mounted () {
    this.fn_SHOW_PROGRESS()
    this.$http.get(`/doctor/presentation`, this.$store.getters.getAuthHeader).then(
      (res) => {
        this.loaded = true
        this.presentation = res.data
        this.fn_HIDE_PROGRESS()
      }
    ).catch(
      (err) => {
        console.log(err)
      }
    )
  },
  watch: {
    presentation (next, prev) {
      if (next.length > 400) {
        this.presentation = prev
      }
    }
  },
  methods: {
    submit () {
      if (this.presentation.length > 400) {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Apresentação muito extensa',
          size: 'md',
          active: true
        })
        return
      }
      this.fn_SHOW_PROGRESS()
      this.sending = true
      this.$http.put(`/doctor/presentation`, {presentation: { presentation: this.presentation }}, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.fn_HIDE_PROGRESS()
          this.sending = false
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Apresentação salva com sucesso',
            size: 'md',
            active: true
          })
        }
      ).catch(
        (err) => {
          console.log(err)
          this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          this.fn_HIDE_PROGRESS()
          this.sending = false
        }
      )
    }
  }
}
</script>
